import { render, staticRenderFns } from "./TextForm.vue?vue&type=template&id=a4cab022&"
import script from "./TextForm.vue?vue&type=script&lang=ts&"
export * from "./TextForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports